import { FieldReadFunction } from '@apollo/client';
import { SessionData } from 'owa-service/lib/types/SessionData';
import * as Schema from 'owa-graph-schema';

type UserConfigurationPolicy = {
    Query: {
        fields: {
            [P in 'userConfiguration']: {
                read: FieldReadFunction<Schema.Query[P], Schema.Query[P] | undefined>;
            };
        };
    };
};

let initialRender = true;

export const unblockBootResolvers = () => {
    initialRender = false;
};

export const createBootPolicies = (sd: SessionData): UserConfigurationPolicy => ({
    Query: {
        fields: {
            userConfiguration: {
                read(existing) {
                    return initialRender
                        ? ((sd.owaUserConfig as unknown) as Schema.UserConfiguration)
                        : existing;
                },
            },
        },
    },
});
